import { render, staticRenderFns } from "./Presencial.vue?vue&type=template&id=1da8566a&scoped=true"
import script from "./Presencial.vue?vue&type=script&lang=js"
export * from "./Presencial.vue?vue&type=script&lang=js"
import style0 from "./Presencial.vue?vue&type=style&index=0&id=1da8566a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da8566a",
  null
  
)

export default component.exports